import N8nScrollArea from './N8nScrollArea.vue';

export default N8nScrollArea;
